import { create } from "zustand";
import type { SearchVehicleDataResult } from "@/lib/cat/mulesoft-vehicle-search";

type RetailVehicleAssignmentStore = {
  muleSoftVehicleData: SearchVehicleDataResult | null;
  setMuleSoftVehicleData: (data: SearchVehicleDataResult | null) => void;
};

export const useRetailVehicleAssignmentStore =
  create<RetailVehicleAssignmentStore>((set) => ({
    muleSoftVehicleData: null,
    setMuleSoftVehicleData: (data) => set({ muleSoftVehicleData: data }),
  }));
